import React from 'react';
import ConfirmationDF from '../components/SimulatorsComponents/DefualtSimulators/ConfirmationDF';
import { weekend_brunch_str } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Sim_F10_RequestPaymentConfirmation = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <ConfirmationDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    showOnlyFirstPage
    withOutLink
    stringButtom={weekend_brunch_str}
    withOutIconLine
    withOutTopTitle
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_F10_RequestPaymentConfirmation;
